// Fusión de los dos escaneos del DNI (anverso y reverso) en un único juego de datos.
//
// Un mismo campo puede venir de las dos caras. Regla de siempre: lo último que se
// escanea pisa lo anterior, salvo los valores nulos. Una excepción, la de los
// apellidos/nombre: si Google Vision se come TODOS los «<» del MRZ del reverso, éste
// devuelve «SANTOSPEREZ» y de él solo no se puede recuperar el corte; el anverso trae
// «SANTOS PEREZ» bien separado. Pisar uno con otro dejaba al socio guardado con los
// apellidos pegados (club, 10-2026). Si los dos valores son el mismo texto salvo por
// los espacios, gana el que está mejor separado, sea cual sea el escaneo que llegó antes.

const CAMPOS_CON_ESPACIOS = ['lastName', 'firstName'];

const sinEspacios = (texto) => texto.replace(/\s+/g, '').toUpperCase();
const contarEspacios = (texto) => (texto.match(/\s/g) || []).length;

// Puro: (datos acumulados, datos del escaneo nuevo) -> datos fusionados.
export function fusionarEscaneoDni(previo, nuevo) {
  const anterior = previo || {};
  const fusionado = {
    ...anterior,
    ...Object.fromEntries(Object.entries(nuevo || {}).filter(([, valor]) => valor != null)),
  };
  CAMPOS_CON_ESPACIOS.forEach((campo) => {
    const antes = anterior[campo];
    const ahora = fusionado[campo];
    if (typeof antes !== 'string' || typeof ahora !== 'string' || !antes || !ahora) return;
    if (antes === ahora || sinEspacios(antes) !== sinEspacios(ahora)) return;
    if (contarEspacios(antes) > contarEspacios(ahora)) fusionado[campo] = antes;
  });
  return fusionado;
}
